import { render, staticRenderFns } from "./PostsAnalysis.vue?vue&type=template&id=e80dbd5c&scoped=true"
import script from "./PostsAnalysis.vue?vue&type=script&lang=js"
export * from "./PostsAnalysis.vue?vue&type=script&lang=js"
import style0 from "./PostsAnalysis.vue?vue&type=style&index=0&id=e80dbd5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80dbd5c",
  null
  
)

export default component.exports